import { SectionsPage } from "@/components/SectionsPage";

export default function Assessments() {
  return (
    <SectionsPage
      seoTitle="Security Assessment Platform | Aliwer"
      seoDescription="Aliwer's security assessment platform helps you identify gaps, prioritize risk, and track remediation with evidence-driven reporting."
      path="/assessments"
      eyebrow="Platform"
      title="Assess risk. Prioritize. Prove progress."
      subtitle="Our security assessment platform turns findings into an actionable, trackable remediation program — the product engine of the Aliwer method."
      sections={[
        { heading: "Guided assessments", body: "Structured assessments mapped to recognized frameworks and real-world risk." },
        { heading: "Prioritized findings", body: "Every finding is risk-rated by exploitability and business impact." },
        { heading: "Remediation tracking", body: "Assign owners, track progress, and demonstrate improvement over time." },
        { heading: "Evidence & reporting", body: "Export audit-ready reports and executive summaries on demand." },
      ]}
      note="[Placeholder] Platform access details and onboarding will be published as the platform rolls out."
      cta={{ label: "Request early access", to: "/contact" }}
      testid="assessments-page"
    />
  );
}
